import { Login } from '../../../../interfaces/auth.interface';
import { Validation } from '../../../../interfaces/common';
import {
  VALIDATION_FIELD_MAPPING,
  APP_ERROR_MESSAGES,
  Regex,
  MaxLength,
  MinLength,
} from '../../../../utils/appConstant';

export const validateLoginForm = (formData: Login, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.username) {
    if (!formData.username.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.username,
        message: APP_ERROR_MESSAGES.login.blankUsername,
      });
    } else if (!Regex.email.test(formData.username.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.username,
        message: APP_ERROR_MESSAGES.login.invalidUsername,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.password) {
    if (!formData.password.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.password,
        message: APP_ERROR_MESSAGES.login.blankPassword,
      });
    } else if (formData.password.length < MinLength.login.password) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.password,
        message: APP_ERROR_MESSAGES.login.shortPassword,
      });
    } else if (formData.password.length > MaxLength.login.password) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.password,
        message: APP_ERROR_MESSAGES.login.longPassword,
      });
    }
  }

  return validations;
};
